import { FormulaCatalogoResolverRequest } from './formula-catalogo-resolver.request';
import { FormulaCatalogoPersonalizacaoRequest } from './formula-catalogo-personalizacao.request';

export class FormulaCatalogoValidarPersonalizacoesRequest extends FormulaCatalogoResolverRequest {
    contextoRaiz: string;
    formulas: FormulaCatalogoPersonalizacaoRequest[] = [];
}
